import React, { useState, useEffect } from 'react';
import images from '../images';
import styles from '../css/Categorias.module.scss'
import { CartaCategoria } from './CartaCategoria';
import { Titulo } from './Titulo';
import axiosRequest from '../axiosRequest';
export const Categorias = () => {

    const [catActual, setCatActual] = useState(0);
    const [cantCatVisibles, setCantCatVisibles] = useState(3);
    const [categorias, setCategorias] = useState([]);

    /*const categorias = [
        { imagen: images.categorias.sierra, nombre: 'Lorem ipsum color met', url: '/productos?category=15' },
        { imagen: images.categorias.auxiliares, nombre: 'Auxiliares para soldadura', url: '/productos?category=15' },
        { imagen: images.categorias.soldadora, nombre: 'Outlet', url: '/productos?category=15' },
        { imagen: images.categorias.auxiliares, nombre: 'Auxiliares para soldadura1', url: '/productos?category=15' },
        { imagen: images.categorias.soldadora, nombre: 'Outlet1', url: '/productos?category=15' },
    ];*/

    useEffect(() => {
        //setCantCatVisibles(Math.floor((window.screen.availWidth - 96)/430))

        axiosRequest.get("/products/categories")
            .onResponse((response) => {
                const categ = response.data.filter(category => category.name !== "Sin categoría");
                setCategorias(categ);
                console.log(categ)
            })
    }, [])

    function mostrarCategoria(i) {
        if (catActual === categorias.length - 1)
            return catActual - 2 <= i && i <= catActual
        else if (catActual === categorias.length - 2)
            return catActual - 1 <= i && i <= catActual + 1
        else if (catActual > 2)
            return catActual <= i && i <= catActual + 2
        else return i <= 2
        /*
        if (catActual === categorias.length - 1)
            return catActual - (cantCatVisibles - 1) <= i && i <= catActual
        else if (catActual === categorias.length - 2)
            return catActual - (cantCatVisibles - 2) <= i && i <= catActual + (cantCatVisibles - 2) 
        else if (catActual > 2)
            return catActual <= i && i <= catActual + (cantCatVisibles - 1)
        else return i <= (cantCatVisibles - 1)*/
    }

    function siguienteCategoria() {
        if (catActual >= categorias.length - cantCatVisibles) {
            setCatActual(0)
        } else {
            setCatActual(catActual + cantCatVisibles)
        }
        console.log(catActual)
    }
    function anteriorCategoria() {
        const aux = categorias.length % cantCatVisibles;
        if (catActual <= 0)
            setCatActual(categorias.length - (aux === 0 ? cantCatVisibles : aux))
        else
            setCatActual(catActual - cantCatVisibles)
        console.log(catActual)
    }
    return (
        <>
            <div className={'container-fluid p-5 ' + styles.categorias}>
                {categorias.length > 0 ? 
                <>
                    <Titulo texto={"NUESTRAS CATEGORÍAS"} subrayar={true} />
                    <img className={styles.fondoIzq} src={images.backgrounds.categorias} />
                    <img className={styles.fondoDer} src={images.backgrounds.categorias} />
                    <img src={images.icons.flecha} className={styles.flechaIzq} onClick={anteriorCategoria} />
                    <img src={images.icons.flecha} className={styles.flechaDer} onClick={siguienteCategoria} />
                    <div className='text-center py-5'>
                        {categorias.map(function (elem, i) {
                            return (
                                mostrarCategoria(i) ?
                                    <CartaCategoria imagen={elem.image ? elem.image.src : ''} nombre={elem.name} url={'/productos?category=' + elem.id} id={'cat' + i}
                                    /*active={i === catActual}*/ />
                                    :
                                    <></>
                            )
                        })}
                    </div>
                </>
                    : <></>

                }
            </div>
        </>
    )

}